import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROLE_HOME_ROUTE } from '../models/roles';

/** Envía "/" al dashboard correspondiente al rol del usuario autenticado. */
export default function RootRedirect() {
  const { user } = useAuth();
  return <Navigate to={ROLE_HOME_ROUTE[user?.role] || '/login'} replace />;
}
